export const MOBILE_WIDTH = 600;
export const TABLET_WIDTH = 992;

const PAYMENT_TAB = 'PAYMENT';
const WORKS_TAB = 'WORKS';
const CONTROL_REPORT_TAB = 'CONTROL_REPORT';
const OFFERS_TAB = 'OFFERS';
const PARTS_TAB = 'PARTS';
const PGA_WORKS_TAB = 'PGA_WORKS';

export const TABS = { PAYMENT_TAB, WORKS_TAB, CONTROL_REPORT_TAB, OFFERS_TAB, PARTS_TAB, PGA_WORKS_TAB };
